import { useEffect } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { ROUTES } from '@/shared/lib/constants';
import { ensureFqnQuotes, parseFqnToPathParts } from '@/shared/lib/format';

export const TagDetailRedirectPage = () => {
  const { tagFqn } = useParams<{ tagFqn: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!tagFqn) return;

    const splitTagFqn = parseFqnToPathParts(tagFqn);

    const selectedTagCategory = splitTagFqn[0];
    const cleanedSelectedTagCategory = ensureFqnQuotes(selectedTagCategory);

    const selectedTagName = splitTagFqn.slice(1).join('.');
    const cleanedSelectedTagName = ensureFqnQuotes(selectedTagName);

    navigate(`${ROUTES.TAGS}/${cleanedSelectedTagCategory}/${cleanedSelectedTagName}`, { replace: true });
  }, [tagFqn, navigate]);
  return <></>;
};
